import React from 'react';

export default function PageSpinner({ message = 'Loading...' }: { message?: string }) {
  return (
    <div className="app-shell flex min-h-[40vh] items-center justify-center px-4" role="status" aria-live="polite">
      <div className="glass-card flex items-center gap-4 p-6">
        <div className="loader-spinner h-10 w-10 rounded-full border-4 border-stone-200" />
        <p className="text-sm font-medium" style={{ color: 'var(--e2s-muted)' }}>{message}</p>
      </div>
    </div>
  );
}
